class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.settings = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        this.productsContainer = this.querySelector(".recently-viewed__items");
        this.productHandles = localStorage.getItem("recentlyProducts");
        this.productHandles = this.productHandles
            ? JSON.parse(this.productHandles)
            : [];

        if (!this.productHandles.length) {
            this.classList.add('hidden');
        } else {
            this.renderProductCards();
        }
    }

    async renderProductCards() {
        this.productHandles = [...new Set(this.productHandles)];

        if (this.productHandles.length > this.settings.max) {
            localStorage.removeItem("recentlyProducts");
            setTimeout(() => {
                localStorage.setItem("recentlyProducts", JSON.stringify(this.productHandles.reverse().slice(0, this.settings.max)));
            }, 200)
        }

        this.productHandles = this.productHandles.reverse().slice(0, this.settings.max);
        let pathUrl = "/collections/all/products";
        const promises = this.productHandles.map((handle) => fetch(`${pathUrl}/${handle}`));

        const results = await Promise.all(promises);
        const dataPromises = results.map((result) => result.text());
        const products = await Promise.all(dataPromises);

        this.productsContainer.innerHTML = '';

        const parser = new DOMParser();

        products.forEach((product) => {
            const prod = parser.parseFromString(product, 'text/html');
            const recElement = prod.querySelector('.recently-product');
            if (recElement) {
                const productHtml = `
                    <div class="products_grid__item recently-product">
                        ${recElement.innerHTML}
                    </div>`;
                this.productsContainer.insertAdjacentHTML('beforeend', productHtml);
            }
        });
    }
}

customElements.define("recently-viewed", RecentlyViewedProducts);
